import { queryOptions, useQuery } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { getReportingRequest } from "lib/api/reference/reporting";
import type { ReportingInterface } from "types/reference";

export const reportingReferenceKeys = {
    all: ["reference", "reporting"] as const,
    list: (languageCode: string) => [...reportingReferenceKeys.all, "list", languageCode] as const,
};

export const fetchReporting = (languageCode: string) =>
    parseResponse<Array<ReportingInterface>>(getReportingRequest(languageCode));

export const reportingReferenceQueryOptions = (languageCode: string) =>
    queryOptions<Array<ReportingInterface>>({
        queryKey: reportingReferenceKeys.list(languageCode || "__missing__"),
        queryFn: () => fetchReporting(languageCode),
        enabled: Boolean(languageCode),
    });

export const useReporting = (languageCode: string) => useQuery(reportingReferenceQueryOptions(languageCode));
